import gql from "graphql-tag";

export const WEATHER_QUERY = gql`
  query weatherValues {
    weatherValues {
      shortForecast
      photo
	  }
  }
`;